import i18n from "config/i18next";

i18n.addResources("es", "capacityDetailModal", {
  pickersWithTrx: "pickers con trx",
  pickersWithoutTrx: "pickers sin trx",
  pickersDisconnected: "Desconectados",
  pickerId: "ID del picker",
  pickerName: "Nombre y apellido",
  whatsapp: "WhatsApp",
  tripId: "Código de viaje",
  trxAmount: "Cantidad de trx",
  noPickersText: "No hay resultados disponibles :(",
  contactText: "¡Hola! {{name}}, ¿cómo estás?, nos comunicamos desde pickers",
});
